import React from "react";
import PropTypes from "prop-types";

const Loader = ({ loading, fullscreen }) => {
    if (!loading) {
        return null;
    }

    const loader = <div className="loader2" />;

    if (!fullscreen) {
        return loader;
    }

    return <div className="loader2-container">{loader}</div>;
};

Loader.propTypes = {
    loading: PropTypes.bool,
    fullscreen: PropTypes.bool,
};

Loader.defaultProps = {
    loading: true,
    fullscreen: true,
};

export default Loader;
